// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__2EZre","active":"Backdrop_active__1-p6L","backdropAnimation":"Backdrop_backdropAnimation__1UzVh"};